import { Modal, message } from 'antd';
import { useCheckDeskBusyQuery, useDeleteDeskMutation } from '../../api/desk';

export const useDeleteDesk = (deskId) => {
  const { isFetching, refetch } = useCheckDeskBusyQuery({
    // params: { deskId, _forDeleteDesk: 'forDeleteDesk' },
    params: { deskId },
    options: { enabled: false },
  });

  const handleSuccess = (data) => {
    if (!data.success) {
      Modal.error({
        title: 'Не удалось удалить стол',
        content: data.message || 'Произошла неизвестная ошибка',
      });
    }
  };

  const { mutateAsync } = useDeleteDeskMutation({ onSuccess: handleSuccess });

  const onDelete = async () => {
    const { data } = await refetch();

    switch (true) {
      case data === 'Error':
        message.error(
          'Не удалось проверить занятость стола на других приемках'
        );
        break;

      case data.length === 0:
        Modal.confirm({
          title: 'Удалить стол?',
          okText: 'Удалить',
          onOk: () => mutateAsync(deskId),
          onCancel: () => {},
        });
        break;

      default:
        Modal.info({
          title: 'Стол нельзя удалить',
          content: `Данный стол используется в следующих приемках: ${data
            .map(({ acceptanceName }) => `«${acceptanceName}»`)
            .join(
              ', '
            )}. Его удаление приведет к ошибкам при работе с этими приемками.`,
          onOk: () => {},
        });
        break;
    }
  };

  return { isCheckDeskLoading: isFetching, onDelete };
};
